const getRouteNames = (route) => {
  const childRouteNames = []
  if (route.children) {
    route.children.forEach(route => childRouteNames.push(...getRouteNames(route)))
  }
  return [
    route.name,
    ...childRouteNames
  ]
}

export const AdvisoryRedirect = (authenticatedRoutes) => {
  const array = []

  authenticatedRoutes.forEach(route => array.push(...getRouteNames(route)))
  return array
}

export default (pages, authenticatedRoutes) => {
  const switchAdvisoryName = (route) => {
    return {
      ...route,
      name: route.name && `advisor-${route.name}`,
      redirect: route.redirect ? {
        name: `advisor-${route.redirect.name}`
      } : undefined,
      children: route.children ? route.children.map(route => switchAdvisoryName(route)) : undefined
    }
  }

  const advisoryCustomerAuthenticatedRoutes = authenticatedRoutes.map(route => switchAdvisoryName(route))

  return {
    path: '/advisory',
    name: 'advisory-authenticated',
    meta: {
      advisory: true,
      authenticated: true
    },
    component: pages.advisoryPage,
    redirect: {
      name: 'advisory-customers'
    },
    children: [
      {
        path: 'customers',
        name: 'advisory-customers',
        component: pages.advisoryCustomers,
        redirect: {
          name: 'customers-list'
        },
        children: [
          {
            path: 'list',
            name: 'customers-list',
            component: pages.advisoryCustomersList
          },
          {
            path: 'add',
            name: 'customers-add',
            component: pages.advisoryCustomersAdd
          },
          {
            path: ':customerId',
            name: 'customer-info',
            component: pages.advisoryCustomerInfos,
            redirect: {
              name: 'customer-overview'
            },
            props: true,
            children: [
              {
                path: 'overview',
                name: 'customer-overview',
                component: pages.customerOverview
              },
              {
                path: 'insights',
                name: 'customer-insights'
              },
              {
                path: 'interactions',
                name: 'customer-interactions',
                component: pages.customerInteractions
              },
              {
                path: 'view',
                name: 'customer-view',
                component: pages.authenticatedPage,
                meta: {
                  view: true
                },
                props: true,
                redirect: {
                  name: 'advisor-dashboard'
                },
                children: advisoryCustomerAuthenticatedRoutes
              }
            ]
          }
        ]
      },
      {
        path: 'stats',
        name: 'advisory-stats'
      },
      {
        path: 'insights',
        name: 'advisory-insights'
      },
      {
        path: 'profile',
        name: 'advisor-profile'
      }
    ]
  }
}
